import React from "react";
import PropTypes from "prop-types";
import { bannerLinkeImg } from '../../../constants/messages/pt-BR';
import Media from "../../Generic/Carousel/CarouselMedia";
import Image from "next/image";
import LazyLoad from 'react-lazy-load';
import Typography from "../../Generic/Typography/Typography";
import styles from "./Section-tw-style.js";
import classNames from "classnames";
const SectionBanner = ({
    title,
    subtitle,
    bannerImage,
    footerText,
    collectionListCollection,
    isMobile,
    isNoWidth
}) => {
    const displayBorderImage = (index) => {
        let isDisplay  = true;
        if(isMobile) {
            if(index === collectionListCollection?.items.length - 1) isDisplay = false;
            else if(index % 2 === 0) isDisplay = true;
            else isDisplay = false;
        } else {
            if(index !== (collectionListCollection?.items.length - 1)) isDisplay = true;
            else isDisplay = false;
        }
        
        return isDisplay;
    };
    const colspan = collectionListCollection?.items.length === 3?'cols-3' :"cols-default"
    const gridColStyle = styles.sectionGridCol[colspan] || styles.sectionGridCol['cols-default'];
    return (
        <div className="section-banner w-full md:min-h-min xl:min-h-min relative overflow-hidden lg:px-0 mb-10 sectionBannerDiv">
            <div className="container mx-auto absolute !px-10 md:px-0 left-0 right-0 top-40 md:top-20 sectionBannerContainer">
                <h2 className="text-black text-22 md:text-50 font-HelveticaNeueBold md:font-BebasNeueBold text-center tracking-wide md:tracking-4">
                    {title}
                </h2>
                <Typography   dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(subtitle),
                                              }} component="h3" className="text-black text-10 md:text-[1.8rem] font-HelveticaNeueLight md:font-BebasNeueBook text-center tracking-wide  mt-10"/>
            </div>
            <Media
                isLazyLoad
                component="bannerPicture"
                srcset={bannerImage.desktopImage?.url}
                image={bannerImage.smartphoneImage?.url}
                altText={bannerImage?.altText}
                priority={true}
                isNoWidth={isNoWidth}
                className="w-full section-banner-img object-cover object-center"
            />
            <div className={`w-full absolute top-16p md:top-25p left-0 right-0   ${gridColStyle} ${isMobile && 'place-items-center'} md:gap-5 px-20 mt-20 mx:mt-0 items-baseline md:items-center`}>
                {collectionListCollection && collectionListCollection.items && collectionListCollection.items.length > 0 &&
                    collectionListCollection.items.map((item, index) => (
                        item && item.iconImageSet ? (
                        <div
                        className={classNames('flex flex-col justify-items-center justify-center items-center md:mb-0 md:max-h-600', (isMobile && (index === collectionListCollection.items.length - 1) && collectionListCollection.items.length<=3) ? 'col-span-2 max-w-50p' : 'col-span-1')}
                        key={index}
                        >
                            <div
                                style={{
                                    borderRight: "12px solid transparent",
                                    borderImage: displayBorderImage(index) ? `url(${bannerLinkeImg}) 30 stretch` : 'none',
                                }}
                                className="flex w-full md:h-auto md:max-h-450 justify-center"
                                data={index}
                            >
                                <Media
                                    isLazyLoad
                                    component="bannerPicture"
                                    srcset={item?.iconImageSet?.desktopImage?.url}
                                    image={item?.iconImageSet?.smartphoneImage?.url}
                                    altText={item?.iconImageSet?.altText}
                                    priority={true}
                                    className="w-full object-cover object-center"
                                />
                            </div>
                            <div className={`text-black text-center ${displayBorderImage(index) ? 'pr-20 md:pr-0' : ''}`}>
                                <h3 className="text-12 md:text-1.4rm font-HelveticaNeueBold">
                                    {item?.title}
                                </h3>
                                <p className="text-9 md:text-15 font-HelveticaNeueBook leading-10 tracking-wide md:tracking-0.48 mt-15 md:mt-10 md:leading-20 sectionBannerDesc">
                                    {item?.description}
                                </p>
                            </div>
                        </div>
                        ) : null
                    ))}
                <div className="footer-text w-full left-0 right-0 col-span-2 md:col-span-4 mt-20">
                    <p className="text-black tracking-0.30 text-center md:text-right font-HelveticaNeueRegular text-8 md:text-.6rm text-block">
                        {footerText}
                    </p>
                </div>
            </div>
        </div>
    );
};

SectionBanner.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    footerText: PropTypes.string,
    bannerImage: PropTypes.object,
    collectionListCollection: PropTypes.array,
    isMobile: PropTypes.bool
};

export default SectionBanner;